import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import { updateAbility } from "@/libs/acl/ability";
import { canNavigate } from "@/libs/acl/routeProtection";
import { getMenuAccessFromToken } from "@/utils/menuAccess";
//Routes
import Dashboard from "./routes/dashboard";
import Auth from "./routes/auth";
import General from "./routes/general";
import Administration from "./routes/administration";
import Promotion from "./routes/promotion";
import Transaction from "./routes/transaction";
import Audit from "./routes/audit";
import Lottery from "./routes/lottery";
import CRM from "./routes/crm";
import Report from "./routes/report";
import Member from "./routes/member";
import SEO from "./routes/seo";
import Rtp from "./routes/rtp";
import Ads from "./routes/ads";
import TelegramAdmin from "./routes/telegramAdmin";

import { GET_TOKEN } from "@/services/local.storage.service";

Vue.use(VueRouter);

const routes = [
    ...Dashboard,
    ...Auth,
    ...General,
    ...Administration,
    ...Promotion,
    ...Transaction,
    ...Audit,
    ...Lottery,
    ...CRM,
    ...Report,
    ...Member,
    ...SEO,
    ...Ads,
    ...Rtp,
    ...TelegramAdmin,
    {
      path: "*",
      redirect: "error-404"
    }
  ]
  
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  
  routes: addRequiresAuthToRoutes(routes),
});

router.beforeEach((to, from, next) => {
  const authRequired = to.meta.requiresAuth;
  const tokenExists = GET_TOKEN() != null;

  if (authRequired && tokenExists) {
    // Update abilities from token before navigation
    const menuAccess = getMenuAccessFromToken();
    if (menuAccess.length > 0) {
      const user = { accessRole: menuAccess };
      updateAbility(user);
    }

    if (to && !canNavigate(to)) {
      return next({ name: "dashboard" });
    }

    return next();
  } else if (authRequired && !tokenExists) {
    return next({ name: "auth-login" });
  } else if (!authRequired && tokenExists) {
    return next({ name: "dashboard" });
  } else {
    return next();
  }
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;

function addRequiresAuthToRoutes(routes) {
  const newRoutes = routes.map(route => {
    if (route.meta && route.meta.requiresAuth == false) {
      return route;
    } else {
      let retVal = {
        ...route,
        meta: {
          ...route.meta,
          requiresAuth: true,
        },
      };
      if (retVal.children) {
        retVal.children = addRequiresAuthToRoutes(retVal.children);
      }

      return retVal;
    }
  });
  return newRoutes;
}